module.exports = __webpack_public_path__ + "static/media/unifonic_logo.ae4a0841.jpg";